<template>
  <div v-if="action.writeMethods">
    <div v-for="(writeMethod, idx) in action.writeMethods" :key="idx">
      <span>Then set value from expression</span>

      <SetValueFromExpression
        v-if="writeMethod.type === 'expression'"
        :eventBus="eventBus"
        :writeMethod="writeMethod"
        :writeMethodIdx="idx"
        :action="action"
        :actionIdx="actionIdx"
        msg="to updated row cell"
        :gridId="sourceGrid"
      />

      <a href="#" @click.prevent="removeWriteMethod(idx)">
        <icon name="remove" />
      </a>
    </div>

    <b-button variant="success" size="sm" @click="addWriteMethod">
      <span v-if="action.writeMethods.length > 0">And</span>
      <span v-else>Do</span>
    </b-button>
  </div>
</template>

<script>
// components
import SetValueFromExpression from '../../../actions/SetValueFromExpression'

export default {
  props: ['eventBus', 'action', 'actionIdx', 'sourceGrid'],
  components: {
    SetValueFromExpression,
  },
  methods: {
    updateAction() {
      this.eventBus.$emit(
        'setAction',
        Object.assign({}, this.action),
        this.actionIdx
      )
    },
    addWriteMethod() {
      this.action.writeMethods.push({ type: 'expression' })

      this.updateAction()
    },
    removeWriteMethod(idx) {
      this.action.writeMethods.splice(idx, 1)

      this.updateAction()
    },
  },
}
</script>
